(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["minimum-order-notice"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('minimum-order-notice')) {
    class MinimumOrderNotice extends HTMLElement {
      connectedCallback() {
        this.country = String(
          this.dataset.country || ''
        ).toUpperCase();

        this.currency =
          sessionStorage.getItem('minimumOrderBucksCurrency') ||
          this.dataset.currency ||
          'EUR';

        this.updateNotice();

        this.handleCurrencyChange =
          this.handleCurrencyChange.bind(this);

        document.addEventListener(
          'BUCKS_SELECTED_CURRENCY',
          this.handleCurrencyChange
        );
      }

      disconnectedCallback() {
        document.removeEventListener(
          'BUCKS_SELECTED_CURRENCY',
          this.handleCurrencyChange
        );
      }

      handleCurrencyChange(event) {
        const detail = event.detail;

        let currency = '';

        if (typeof detail === 'string') {
          currency = detail;
        } else if (detail && typeof detail === 'object') {
          currency =
            detail.currency ||
            detail.selectedCurrency ||
            detail.currencyCode ||
            detail.code ||
            '';
        }

        this.currency = String(currency || 'EUR').toUpperCase();

        sessionStorage.setItem(
          'minimumOrderBucksCurrency',
          this.currency
        );

        this.updateNotice();
      }

      updateNotice() {
        const currency = String(
          this.currency || 'EUR'
        ).toUpperCase();

        if (this.country === 'UA' || currency === 'UAH') {
          this.hidden = true;
          return;
        }

        const minimumValue = this.querySelector(
          '[data-minimum-value]'
        );

        if (minimumValue) {
          minimumValue.textContent =
            currency === 'USD' ? '$230' : '€200';
        }

        this.hidden = false;
      }
    }

    customElements.define(
      'minimum-order-notice',
      MinimumOrderNotice
    );
  }
  } catch(e) { console.error(e); }
})();

})();
